import './dropdown-menus.js';
import './site-map.js';
import './site-search.js';
import './sub-pages.js';
import navigation from './nav-toggle.js';
import credits from './image-credit.js';
import SubmenuNavigation from './submenu-navigation.js';

( function( $ ) {

  $( document ).ready( function() {

    $( 'body' ).addClass( 'js-active' );

        let subNav = new SubmenuNavigation();
        subNav.init();

        let navToggle = new navigation();
        navToggle.init();

        let credit = new credits();
        credit.init();

        $( '.is-style-read-more' ).readmore(
            {
                embedCSS: false,
                collapsedHeight: 300,
                heightMargin: 50,
                moreLink: '<a href="#" class="readmore-toggle">Read more<i class="fa fa-angle-down" aria-hidden></i></a>',
                lessLink: '<a href="#" class="readmore-toggle"><i class="fa fa-angle-up" aria-hidden></i>Less</a>'
            }
        );

        document.querySelectorAll('a[href^="#"]').forEach(anchor => {

            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                });
            });
        });

  });

} )( jQuery );
